import { useEffect, useState } from "react";
import { usePathname } from "@lib/i18n/navigation-app-router";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useSearchParams } from "next/navigation";

export function useButtonEventTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [path, setPath] = useState("/");

  useEffect(() => {
    const query = searchParams.toString() ? `?${searchParams.toString()}` : "";
    setPath(`${pathname}${query}`);
  }, [pathname, searchParams]);

  return (trackingName, buttonName, userGroup, eventAdditionalData) => {
    const defaultButtonEventData = {
      tracking_name: trackingName,
      button: buttonName,
      page: path,
      ...eventAdditionalData,
    };

    function extractHubAndListingSlugs() {
      const pathParts = pathname.split("/");
      const hubSlug = pathParts[1] || null;
      const listingSlug = pathParts.length > 2 ? pathParts[pathParts.length - 1] : null;

      return { hubSlug, listingSlug };
    }

    if (userGroup) defaultButtonEventData.user_group = userGroup;

    if (path?.includes("catalogue") || path?.includes("braderie")) {
      const { hubSlug, listingSlug } = extractHubAndListingSlugs();

      const catalogData = {
        ...defaultButtonEventData,
        hub_slug: hubSlug,
        listing_slug: listingSlug,
      };

      ahoy("$click", catalogData);
      analytics.track("$click", catalogData);
      return;
    }

    ahoy("$click", defaultButtonEventData);
    analytics.track("$click", defaultButtonEventData);
  };
}
